// extracted by mini-css-extract-plugin
module.exports = {"container":"RealNamePopup_container_dxtIb","dialog":"RealNamePopup_dialog_2CPXm","btn_cancel":"RealNamePopup_btn_cancel_1LER_"};